import {Controller} from "stimulus";
import 'select2/dist/css/select2.css';
import '@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.min.css';
import 'select2';
import 'select2/dist/js/i18n/bg';

export default class extends Controller {
    initialize() {
        let language = document.documentElement.lang;

        this.ajaxUrl = this.element.getAttribute("data-ajax-url");
        this.eventOnSelect = this.element.getAttribute("data-event-on-select");
        this.maximumSelectionLength = this.element.getAttribute("data-maximum-selection-length");
        this.params = {
            theme: 'bootstrap4',
            language: language,
        };

        if (this.maximumSelectionLength !== null) {
            this.params.maximumSelectionLength = 3;
        }
        if (this.ajaxUrl !== null) {
            this.params = {

                theme: 'bootstrap4',
                language: language,
                minimumInputLength: 3,
                tags: false,
                ajax: {
                    url: this.ajaxUrl,
                    dataType: 'json',
                    type: "GET",
                    quietMillis: 50,
                    createTag: function (params) {
                        return undefined;
                    },
                    data: function (params) {

                        let queryParameters = {
                            term: params.term
                        };

                        return queryParameters;
                    },
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name + ' ( ' + item.code + ' / ' + item.subCode + ' )',
                                    id: item.id
                                }
                            })
                        };
                    }
                }
            };
        }
    }

    connect() {
        const $element = $(this.element);

        if ($element.hasClass('select2entity')) {
            if (!$element.hasClass('select2-hidden-accessible')) {
                $element.select2entity();
            }
        } else if (!$element.hasClass('select2-hidden-accessible')) {
            $element.select2(this.params);
        }

        this.bindUnselectFix($element);
        this.bindClearAll($element);

        const _self = this;

        if (this.eventOnSelect) {
            $element.on('select2:select', function (e) {
                EventManager.fire(_self.eventOnSelect, e.params.data.id);
            });
        }
    }

    disconnect() {
        const $element = $(this.element);
        $element.off('.select2unselectfix');
        $element.off('.select2clearall');

        if (this._clearAllButton) {
            this._clearAllButton.remove();
            this._clearAllButton = null;
        }

        if (this._select2Container && this._onRemoveMouseDown) {
            this._select2Container.removeEventListener('mousedown', this._onRemoveMouseDown, true);
        }

        this.restoreFocusPatches();
    }

    /**
     * Clicking × focuses the tall .select2-selection / original <select>.
     * If those are off-screen, the browser scrolls them into view before mouseup,
     * so the click misses × and opens the dropdown instead.
     */
    bindUnselectFix($element) {
        const container = $element.next('.select2-container')[0];
        if (!container) {
            return;
        }

        this._select2Container = container;
        this.patchFocusPreventScroll(this.element);
        this.patchFocusPreventScroll(container.querySelector('.select2-selection'));
        this.patchFocusPreventScroll(container.querySelector('.select2-search__field'));

        this._onRemoveMouseDown = (event) => {
            if (event.target.closest('.select2-clear-all')) {
                event.preventDefault();
                event.stopPropagation();
                $element.val(null).trigger('change');
                return;
            }

            if (event.target.closest('.select2-selection__choice__remove, .select2-selection__clear')) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        container.addEventListener('mousedown', this._onRemoveMouseDown, true);

        $element.on('select2:unselecting.select2unselectfix', () => {
            $element.data('unselecting', true);
            this.patchFocusPreventScroll(container.querySelector('.select2-search__field'));
        });

        $element.on('select2:opening.select2unselectfix', function (e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        });
    }

    patchFocusPreventScroll(element) {
        if (!element) {
            return;
        }
        if (!this._focusPatches) {
            this._focusPatches = new Map();
        }
        if (this._focusPatches.has(element)) {
            return;
        }

        const originalFocus = element.focus.bind(element);
        element.focus = (options) => {
            const opts = (typeof options === 'object' && options !== null) ? options : {};
            originalFocus({...opts, preventScroll: true});
        };
        this._focusPatches.set(element, originalFocus);
    }

    bindClearAll($element) {
        const isMultiple = this.element.multiple || this.element.hasAttribute('multiple');
        if (!isMultiple || !this._select2Container) {
            return;
        }

        let button = this._select2Container.nextElementSibling;
        if (!button || !button.classList.contains('select2-clear-all')) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'select2-clear-all';
            button.textContent = 'изтрий всички';
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                $element.val(null).trigger('change');
            });
            this._select2Container.insertAdjacentElement('afterend', button);
        }

        this._clearAllButton = button;

        const updateVisibility = () => {
            const value = $element.val();
            const selectedCount = $element.find('option:selected').filter((_, option) => option.value !== '').length;
            const hasValue = selectedCount > 0 || (Array.isArray(value) ? value.length > 0 : Boolean(value));
            button.hidden = !hasValue;
        };

        $element.on('change.select2clearall select2:select.select2clearall select2:unselect.select2clearall', updateVisibility);
        updateVisibility();
    }

    restoreFocusPatches() {
        if (!this._focusPatches) {
            return;
        }

        this._focusPatches.forEach((originalFocus, element) => {
            element.focus = originalFocus;
        });
        this._focusPatches.clear();
    }
}
